import {
  Component,
  Input,
  OnChanges,
  OnInit,
  SimpleChanges,
} from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { catchError, of, tap } from 'rxjs';
import { environment } from '../environments/environment';
import { CommonModule } from '@angular/common';
import { Keyword } from '../modules/model-viewer-urbasee/entities/keyword.entity';

/**
 * Composant pour afficher l'aperçu d'un variant sur une pastille
 *
 * La pastille est composée de deux parties :
 * - La partie principale (basee), qui correspond à la couleur principale du variant (couleur rgb ou motif)
 * - La partie secondaire factultative (haute), qui correspond à la couleur secondaire du variant (couleur rgb ou motif)
 *
 */

@Component({
  imports: [CommonModule],

  selector: 'app-keyword-preview',
  styles: [
    `
      ::ng-deep app-keyword-preview {
        height: 100%;
        position: relative;
        display: block;
      }
    `,
  ],
  template: `
    <div *ngIf="name" style="">{{ name }}</div>
    <div
      [style]="{
                background: '#4b3d3d',
                'background-size': 'contain',
                width: '100%',
                height: '100%',
                position: 'absolute',
              }"
    ></div>
    <div
      *ngIf="motif"
      [style]="{
                background: motif?'url(' + motif + ')':'',
                'background-repeat': 'no-repeat',
                'background-size': '70%',
                'background-position': 'center',
                width: '100%',
                height: '100%',
                position: 'absolute',
              }"
    ></div>
  `,
  standalone: true,
})
export class KeywordPreviewComponent implements OnInit, OnChanges {
  public name?: string;
  @Input('keyword-name') keywordName?: string;
  @Input('keywords') keywords?: Keyword[];
  @Input('alternative-name') alternativeName?: string;

  public motif?: string;

  constructor(private httpClient: HttpClient) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (
      !this.motif &&
      ((changes['keywordName'] && !changes['keywordName'].firstChange) ||
        (changes['keywords'] && !changes['keywords'].firstChange))
    ) {
      this.ngOnInit();
    }
  }

  ngOnInit(): void {
    this.name = undefined;

    if (!this.keywordName) {
      throw new Error(`[Model-Viewer-Urbasee] keyword missing`);
    }
    if (!this.keywords || this.keywords.length === 0) {
      console.warn(`[Model-Viewer-Urbasee] keywords missing`);
    }

    const keyword = this.keywords?.find((k) => k.name === this.keywordName);

    if (keyword && keyword.hasKeywordImage) {
      this.httpClient
        .get(
          `${environment.apiUrl}/services/v4.0/media/${keyword.keywordImage.id}/download`,
          {
            responseType: 'blob',
          }
        )
        .pipe(
          tap((blob) => {
            this.motif = URL.createObjectURL(blob);
          }),
          catchError((error) => {
            this.name = this.alternativeName || this.keywordName;
            return of();
          })
        )
        .subscribe();
    } else {
      this.name = this.alternativeName || this.keywordName;
    }
  }
}
